import { generateEntityCrudReducer } from 'syft-acp-util/store/reducers'

import { actionTypes } from './action-types'
import type { ConfiguredUpliftEntity } from './types'

/**
 * Keyed by scope, not by employer: a client answer and one of its venues' answers are different
 * answers and must not overwrite each other. That keying, together with `useConfiguredUplift`
 * selecting only the key for the scope on screen, is what stops one scope's figure appearing
 * under another while the next request is in flight.
 */
export const reducer = generateEntityCrudReducer<ConfiguredUpliftEntity>({
  name: 'configuredUplift',
  actions: actionTypes,
  options: { idKey: 'scope_key' },
})
